import React from 'react'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import moment from 'moment';
import 'moment/locale/es';

function createData(openDate, openMount, closeMount, openAndClose, user) {
  return { openDate, openMount, closeMount, openAndClose, user };
}

const rows = [
  createData(moment().format('DD/MM/YYYY'), 80, 0, 80, 'Admin'),
];


const CashOpen = () => {
  return (
    <>
        <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                <TableRow>
                    <TableCell>Fecha de apertura</TableCell>
                    <TableCell>Monto de apertura</TableCell>
                    <TableCell>Monto sin cerrar</TableCell>
                    <TableCell>Cierre + Apertura</TableCell>
                    <TableCell>Responsable</TableCell>
                </TableRow>
                </TableHead>
                <TableBody>
                {rows.map((row) => (
                    <TableRow
                    key={row.code}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                    <TableCell component="th" scope="row">{row.openDate}</TableCell>
                    <TableCell>${row.openMount}</TableCell>
                    <TableCell>${row.closeMount}</TableCell>
                    <TableCell>${row.openAndClose}</TableCell>
                    <TableCell>{row.user}</TableCell>
                    </TableRow>
                ))}
                </TableBody>
            </Table>
        </TableContainer>
    </>
  )
}

export default CashOpen